import React from "react";
import { Menu, MenuItem, IconButton, Tooltip, Button } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAuth } from "../../Context/AuthContext";
import { useLoading } from "../../Context/LoadingContext";
import { useTranslation } from "react-i18next";
interface ItemActionsProps {
    onCopy: () => void;
    onDelete: () => void;
    onCreate?: () => void;
    stockQuickView?: () => void;
    suggestItem?: () => void;
    priceList?: () => void;
}
const ItemActions: React.FC<ItemActionsProps> = ({
    onCopy,
    onDelete,
    onCreate,
    stockQuickView,
    suggestItem,
    priceList
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <>
            <Tooltip title="Actions">
                <Button variant="contained" onClick={handleClick}
                    endIcon={<MoreVertIcon />}
                    size="small"
                >
                    {t("common.actions")}
                </Button>

            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {stockQuickView && (<MenuItem onClick={() => { handleClose(); stockQuickView(); }}>{t("common.stockInformation")}</MenuItem>)}
                {priceList && (<MenuItem onClick={() => { handleClose(); priceList(); }}>{t("common.pricelist")}</MenuItem>)}
                <MenuItem onClick={() => { handleClose(); onCopy(); }}>{t("common.copy")}</MenuItem>
                {onCreate && (<MenuItem onClick={() => { handleClose(); onCreate(); }}>{t("common.createNew")}</MenuItem>)}
                {suggestItem && (<MenuItem onClick={() => { handleClose(); suggestItem(); }}>{t("common.aiSuggest")}</MenuItem>)}
                {}
                <MenuItem onClick={() => { handleClose(); onDelete(); }} style={{ color: "red" }}>{t("common.delete")}</MenuItem>



            </Menu>
        </>
    );
};
export default ItemActions;